import { render, staticRenderFns } from "./registeredEvents.vue?vue&type=template&id=1e44021e"
import script from "./registeredEvents.vue?vue&type=script&lang=js"
export * from "./registeredEvents.vue?vue&type=script&lang=js"
import style0 from "./registeredEvents.vue?vue&type=style&index=0&id=1e44021e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports